import React from "react";
import { ALL_CENTERS, CentersView } from "./Centers";

const INTERNATIONAL_CENTERS = ALL_CENTERS.filter(
  (center) => center.country !== "India",
);

function InternationalCenters() {
  return (
    <CentersView
      title="International Centers"
      subtitle="Centers outside India"
      centers={INTERNATIONAL_CENTERS}
    />
  );
}

export default InternationalCenters;
